import React, { Component } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';

class About extends Component {
    render() {
        return (
            <div className="site-wrap">
                <Header page={'about'} />
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><strong className="text-black">About</strong></div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className='textpara col-md-12'>
                                Welcome to <strong>Pelican Edu-Supply</strong>– your trusted partner in providing high-quality educational products and resources! <br />
                                At Pelican Edu-Supply, we are passionate about supporting students, educators, and schools with the best educational tools and supplies. Whether you're looking for textbooks, stationery, teaching aids, or learning materials, we strive to provide a comprehensive range of products designed to enhance learning experiences and foster academic growth.
                                <br /> <br />
                                <strong>Our Mission</strong><br />
                                Our mission is simple: to make education accessible and enjoyable by offering high-quality, affordable, and reliable educational products. We aim to empower learners of all ages and support educators in their mission to inspire and educate.
                                <br /><br />
                                <strong>What We Offer</strong><br />
                                               We provide a wide selection of products, including:<br/>
                                <ul>  
                                    <li>Educational books and textbooks</li>
                                    <li>Stationery for students and teachers</li>
                                    <li>Learning tools and aids</li>
                                    <li>School supplies and equipment</li>
                                </ul>
                                Our products are carefully selected to ensure that they meet the highest standards of quality and relevance to today’s educational needs. We work closely with renowned brands and trusted suppliers to bring you the very best.
                                <br /><br />

                                <strong>Why Choose Pelican Edu-Supply?</strong><br />
                                <ul>
                                    <li><strong>Wide Selection:</strong> We offer a diverse range of educational products to meet every need.</li>
                                    <li><strong>Affordable Prices:</strong> We believe in making quality education products accessible to everyone.</li>
                                    <li><strong>Customer-Focused:</strong>  Your satisfaction is our priority. We provide personalized customer service to ensure a smooth and hassle-free shopping experience.
                                    </li>
                                    <li><strong>Reliability:</strong>  We pride ourselves on delivering products on time and in perfect condition.</li>
                                </ul>

                                <br />



                                <strong>Our Commitment</strong><br />
                                We are committed to supporting the educational community, whether you are a student looking to expand your knowledge, a teacher seeking teaching resources, or a parent searching for the best materials for your child's learning journey. We believe in the power of education to transform lives, and we’re here to help make that transformation a reality.


                                <br /><br />



                                <strong>Join Us on Our Journey</strong><br />

                                At Pelican Edu-Supply, we’re more than just a store – we are your partner in education. Explore our wide range of products and see how we can support your educational goals. We’re excited to be a part of your learning journey!

                                <br /><br />
                                Thank you for choosing Pelican Edu-Supply!
                                </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default About;